<!--
    Styles
-->

<style>

    .ui-checkbox {
        position: relative;
        width: 16px;
        height: 16px;
        background: var(--cl-white);
        border: 1px solid var(--cl-gray);
        border-radius: 1px;
    }
    .ui-checkbox.active:before {
        content: '';
        position: absolute;
        top: 4px;
        left: 4px;
        width: 6px;
        height: 6px;
        background: var(--cl-blue);
    }

</style>



<!--
    Template
-->

<template>
    <div class="ui-checkbox" :class="{active}" />
</template>



<!--
    Scripts
-->

<script>

    export default {

        props: [
            'active'
        ]

    }

</script>

